import { styles as inputBaseStyles } from "@material-ui/core/InputBase/InputBase";
import { styles as buttonStyles } from "@material-ui/core/Button/Button";
import { styles as collapseStyles } from "@material-ui/core/Collapse/Collapse";
import { styles as containerStyles } from "@material-ui/core/Container/Container";
import { styles as gridStyles } from "@material-ui/core/Grid/Grid";
import { styles as iconButtonStyles } from "@material-ui/core/IconButton/IconButton";
import { styles as buttonBaseStyles } from "@material-ui/core/ButtonBase/ButtonBase";
import { styles as touchRippleStyles } from "@material-ui/core/ButtonBase/TouchRipple";
import { styles as linkStyles } from "@material-ui/core/Link/Link";
import { styles as listStyles } from "@material-ui/core/List/List";
import { styles as listItemStyles } from "@material-ui/core/ListItem/ListItem";
import { styles as menuItemStyles } from "@material-ui/core/MenuItem/MenuItem";
import { styles as typographyStyles } from "@material-ui/core/Typography/Typography";
import { styles as privateNotchedOutlineStyles } from "@material-ui/core/OutlinedInput/NotchedOutline";
import { styles as outlinedInputStyles } from "@material-ui/core/OutlinedInput/OutlinedInput";
import { styles as formLabelStyles } from "@material-ui/core/FormLabel/FormLabel";
import { styles as inputLabelStyles } from "@material-ui/core/InputLabel/InputLabel";
import { styles as formControlStyles } from "@material-ui/core/FormControl/FormControl";
import { styles as paperStyles } from "@material-ui/core/Paper/Paper";
import { styles as popoverStyles } from "@material-ui/core/Popover/Popover";
import { styles as snackbarContentStyles } from "@material-ui/core/SnackbarContent/SnackbarContent";
import { styles as svgIconStyles } from "@material-ui/core/SvgIcon/SvgIcon";
import { styles as textFieldStyles } from "@material-ui/core/TextField/TextField";

export const pseudoClasses = [
  "checked",
  "disabled",
  "error",
  "focused",
  "focusVisible",
  "required",
  "expanded",
  "selected",
];

export const stylesMap = {
  MuiButton: buttonStyles,
  MuiButtonBase: buttonBaseStyles,
  MuiCollapse: collapseStyles,
  MuiContainer: containerStyles,
  MuiFormControl: formControlStyles,
  MuiFormLabel: formLabelStyles,
  MuiGrid: gridStyles,
  MuiIconButton: iconButtonStyles,
  MuiInputBase: inputBaseStyles,
  MuiInputLabel: inputLabelStyles,
  MuiLink: linkStyles,
  MuiList: listStyles,
  MuiListItem: listItemStyles,
  MuiMenuItem: menuItemStyles,
  MuiOutlinedInput: outlinedInputStyles,
  MuiPaper: paperStyles,
  MuiPopover: popoverStyles,
  MuiSnackbarContent: snackbarContentStyles,
  MuiSvgIcon: svgIconStyles,
  MuiTextField: textFieldStyles,
  MuiTouchRipple: touchRippleStyles,
  MuiTypography: typographyStyles,
  PrivateNotchedOutline: privateNotchedOutlineStyles,
};

/**
 *
 * @param {object} [cfg] config object
 * @param {string} [cfg.prefix=N0] className prefix of auto-generation when stylesheet name is not defined
 * @returns {string} className for material-ui / jss
 * @example
 * // stylesheet name is defined
 * const useStyle = makeStyles(
 *   theme => ({ root: {} }),
 *   { name: 'Component' },
 * );
 * const classes = useStyle(); // classes.root === 'Component-root'
 * @example
 * // stylesheet name is not defined
 * // stylesheet name is defined
 * const useStyle = makeStyles(
 *   theme => ({ root: {} }),
 * );
 * const classes = useStyle(); // classes.root === 'N0-123'
 */
export const createClassNameGenerator = (cfg) => {
  const prefix = cfg?.prefix ?? "N0";
  let counter = 1;
  return (rule, sheet) => {
    const className = `${sheet.options.classNamePrefix}-${rule.key}`;
    // when stylesheet name is found, return a static / fixed className for material-ui to use
    if (sheet.options.name) {
      return className;
    } else {
      // when stylesheet name is not found, return a auto-generated className
      const autoGenerateClassName = `${prefix}-${counter++}`;
      console.warn(
        `Unnamed style found, mapped className from "${className}" to "${autoGenerateClassName}".`,
      );
      return autoGenerateClassName;
    }
  };
};

export const computeFontStyle = (type, baseFontSize = 14) => {
  const THEME = {
    // fontSize and lineHeight in px
    metadata: { fontSize: 10, lineHeight: 16, letterSpacing: "0.03em" },
    label: { fontSize: 12, lineHeight: 16, letterSpacing: "0.11em" },
    caption: { fontSize: 12, lineHeight: 16 },
    body: { fontSize: 14, lineHeight: 20 },
    h5: { fontSize: 14, lineHeight: 20 },
    h4: { fontSize: 16, lineHeight: 24 },
    h3: { fontSize: 18, lineHeight: 24 },
    h2: { fontSize: 24, lineHeight: 32 },
    h1: { fontSize: 32, lineHeight: 40 },
    display2: { fontSize: 48, lineHeight: 54 },
    display1: { fontSize: 80, lineHeight: 96 },
  };
  let style = typeof type === "string" ? (THEME[type] ?? THEME.body) : type;
  style.lineHeight /= style.fontSize; // convert to ratio
  style.fontSize *= baseFontSize / THEME.body.fontSize; // scale font size
  return style;
};
